import type { WhatsNewBody } from '../types';

export default {
  title: 'Update a month’s forecast until accounting closes it',
  summary:
    'On a job’s Financials tab, a month that has ended but that accounting has not closed can now have its forecast updated. Pick the month in the View menu and use Update Forecast. Closing the month is what locks it.',
  details: [
    'The View menu lists each month. One that is not closed offers Update Forecast, named for the month, and saves cost to complete for that month only.',
    'It does not touch the current forecast, which is saved separately. A change that applies to both the past month and today has to be entered on each.',
    'Budget transfers and cost build-ups are still on the Current view. They keep no record for a past month.',
    'Once accounting closes the month, its forecast is final and Update Forecast is gone. If accounting reopens it, it can be updated again.',
    'The contract, estimate and purchase orders in a month are still as they stood at month end, and cost is every entry dated in the month.',
  ],
  audience: { label: 'project managers and accounting', test: (a) => a.viewsFinancials },
  tryIt: { to: '/projects', label: 'Open Projects' },
} satisfies WhatsNewBody;
